// extracted by mini-css-extract-plugin
export default {"wrapper":"Yx-z","viewport":"Zx-z","container":"_x-z","slide":"ay-z"};